import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { scrollBarStyling } from 'src/styles/styles';

import { colors } from '../../../styles/colors';
import { ZeeFontBold, ZeeFontRegular } from '../../../styles/font';
import { MediaBP as MQ } from '../../../styles/mediaQuery';
import { flex } from '../../../styles/utils';

export const recentSearchWrapper = (
  topSearchLength: number,
  recentSearchDataLength: number
) => css`
  ${ZeeFontRegular(14, 48)};
  color: ${colors.PrimaryWhiteColor};
  background-color: ${colors.primaryBgColor};
  ${flex('column', '', '')}
  text-align: left;
  position: absolute;
  left: 16px;
  right: 0;
  padding-right: 10px;
  padding-bottom: 16px;
  top: 85px;
  bottom: 0px;
  overflow: hidden;
  overflow-y: auto;
  ${scrollBarStyling(
    '6px',
    colors.PrimaryBlackColorAlpha20,
    colors.PrimaryWhiteColorAlpha05
  )};
  z-index: 2;
  ${MQ.MediaLg} {
    top: 40px;
    left: 0;
    right: 0;
    bottom: auto;
    max-height: 80vh;
    padding: ${topSearchLength === 0 && recentSearchDataLength === 0
      ? '0px'
      : `16px 10px 16px 16px`};
  }
`;

export const recentSearchHeader = css`
  ${ZeeFontBold(16, 24)};
  color: ${colors.PrimaryWhiteColor};
  ${flex('row', 'space-between')};
`;

export const recentSearchLbl = css`
  ${ZeeFontBold(16, 24)};
  float: left;
  color: ${colors.PrimaryWhiteColor};
  padding: 10px 0;
`;

export const recentSearchClear = css`
  ${ZeeFontRegular(14, 22)};
  cursor: pointer;
  padding: 10px 5px;
  color: ${colors.PurpleLight};
`;

export const recentSearchListWrap = css`
  overflow: hidden;
  max-height: 86px;
  ${flex()};
`;

export const recentSearchList = css`
  ${flex()};
  position: relative;
  float: left;
  box-sizing: border-box;
  padding: 0 8px 0 16px;
  z-index: 1;
  background: ${colors.SearchCardBg};
  border: 1px solid ${colors.PrimaryWhiteColorAlpha10};
  border-radius: 18px;
  margin: 0 8px 8px 0;
  max-width: 219px;
  ${MQ.MediaLg} {
    &:hover {
      background: ${colors.RecentSearchListOnHover};
    }
  }
`;

export const searchitem = css`
  ${ZeeFontRegular(14, 16)};
  color: ${colors.Grey88};
  padding: 9px 0;
  padding-right: 8px;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const viewAllCss = css`
  display: flex;
  overflow-x: scroll;
`;

export const closeIcon = css`
  margin-left: auto;
  cursor: pointer;
  font-size: 28px;
  line-height: 16px;
`;

export const searchOverlyFocus = css`
  margin: auto;
  z-index: 2;
`;

export const noSearchHistory = css`
  ${MQ.MediaLg} {
    display: none;
  }
  &:before {
    content: '';
    display: block;
    width: 120px;
    height: 120px;
    background: url('/webapp-assets/images/search_error.svg') no-repeat center;
  }
  h3 {
    ${ZeeFontBold(14, 20)};
    margin-bottom: 5px;
    color: ${colors.PrimaryWhiteColor};
  }
  p {
    ${ZeeFontRegular(12, 16)}
    color: ${colors.AccentInfoPopupDescriptionMobileColor};
  }
`;

export const allListContainer = css`
  display: flex;
  flex-direction: column;
`;

export const RecentSearchHeader = styled.div`
  ${recentSearchHeader}
`;
export const RecentSearchLbl = styled.div`
  ${recentSearchLbl}
`;
export const RecentSearchClear = styled.span`
  ${recentSearchClear}
`;
export const Searchitem = styled.div`
  ${searchitem}
`;
export const CloseIcon = styled.span`
  ${closeIcon}
`;
export const SearchOverlyFocus = styled.div`
  ${searchOverlyFocus}
`;
export const NoSearchHistory = styled.div`
  ${noSearchHistory}
`;
